<template>
  <div class="card">
    <slot></slot>
  </div>
</template>

<style scoped>
  .card {
    box-shadow: 0 5rem 5rem rgba(0, 0, 0, 0.5);
    padding: 2rem;
    border-radius: 1rem;
    margin: auto;
    max-width: 60rem;
  }
</style>
